<template>
  <div v-if="showFields">
    <div class="fabricWeightInput">
      <div class="label">{{ Title }}</div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="inlineRadioOptions"
          id="inlineRadio1"
          value="standard"
          @change="$emit('onChange', handleEmit($event.target))"
          :checked="weightType == 'standard'"
        />
        <label class="form-check-label" for="inlineRadio1">{{ standard }}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="inlineRadioOptions"
          id="inlineRadio2"
          value="heavy"
          @change="$emit('onChange', handleEmit($event.target))"
          :checked="weightType == 'heavy'"
        />
        <label class="form-check-label" for="inlineRadio2">{{ heavy }}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="inlineRadioOptions"
          id="inlineRadio3"
          value="light"
          @change="$emit('onChange', handleEmit($event.target))"
          :checked="weightType == 'light'"
        />
        <label class="form-check-label" for="inlineRadio3">{{ light }}</label>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    Title: {
      type: String,
      default: ""
    },
    weightType: {
      type: String,
      default: ""
    },
    showFields: {
      type: Boolean,
      default: false
    }
  },
  emits: ["onChange"],
  data() {
    return {
      standard: this.$t("fabricWeightComp.standard"),
      heavy: this.$t("fabricWeightComp.heavy"),
      light: this.$t("fabricWeightComp.light")
    };
  },
  methods: {
    handleEmit(target: EventTarget | null) {
      return (target as HTMLInputElement).value;
    }
  }
});
</script>

<style scoped>
.label {
  font-size: 16px;
}
.form-check-label {
  font-size: 15px;
}
.fabricWeightInput {
  height: 57px;
}
.form-check-input:checked {
  background-color: #ffffff;
  border-color: #858585;
  background-image: radial-gradient(circle at center, #858585 50%, transparent 40%);
}

.form-check-input {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.75) !important;
}
</style>
